import { render, staticRenderFns } from "./ProductRatesModal.vue?vue&type=template&id=1d5b668a&scoped=true"
import script from "./ProductRatesModal.vue?vue&type=script&lang=ts"
export * from "./ProductRatesModal.vue?vue&type=script&lang=ts"
import style0 from "./ProductRatesModal.vue?vue&type=style&index=0&id=1d5b668a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b668a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d5b668a')) {
      api.createRecord('1d5b668a', component.options)
    } else {
      api.reload('1d5b668a', component.options)
    }
    module.hot.accept("./ProductRatesModal.vue?vue&type=template&id=1d5b668a&scoped=true", function () {
      api.rerender('1d5b668a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/components/ProductRatesModal.vue"
export default component.exports